export const getHeightFromMarginBottom = (marginBottomClass, isMobile) => {
  const marginsDesktop = {
    margin__bottom__240: 240,
    margin__bottom__160: 160,
    margin__bottom__80: 80,
    margin__bottom__0: 240,
  };

  const marginsMobile = {
    margin__bottom__240: 120,
    margin__bottom__160: 72,
    margin__bottom__80: 40,
    margin__bottom__0: 72,
  };

  const selectedMargins = isMobile ? marginsMobile : marginsDesktop;
  return selectedMargins[marginBottomClass] || 0;
};
